import { composeDecoratedDetailSearchFilter } from 'utils/insightModal/composeDecoratedDetailSearchFilter'
import { composeDecoratedDrillDownWidgetSetting } from 'utils/insightModal/composeDecoratedDrillDownWidgetSetting'
import { DecoratedSearchFilterComposingStrategy } from 'utils/insightModal/strategy/searchFilterComposing/decorator/type'
import { DecoratedWidgetSettingComposingStrategy } from 'utils/insightModal/strategy/widgetSettingComposing/decorator/type'
import { InsightContentSettingType } from 'components/insightContent/types'
import AnalysisFilter from 'types/analysisFilter'
import { toFilter } from '../../../../../utils/widgetUtil'
import { CrosstabWidgetsType, InsightObjective } from '../../types'

export const convertToInsightContentSetting = (
  widgetSetting: CrosstabWidgetsType,
  strategy: DecoratedSearchFilterComposingStrategy,
  selection?: InsightObjective
) => {
  const {
    viewOption,
    topicInfos,
    rowComparisonMode,
    colComparisonMode,
    pivotThemeInfos,
    pivotRowThemeInfos,
    tagNames,
    rowTagNames,
    docNames,
    rowDocNames
  } = widgetSetting
  const {
    topicId,
    insight,
    pivot,
    selectedPivotThemeInfo,
    selectedPivotRowThemeInfo,
    selectedTagName,
    selectedRowTagName,
    selectedDocName,
    selectedRowDocName
  } = selection!

  const insightContentSetting = ({
    viewOption: viewOption!,
    emptyInsight: false,
    filter: toFilter(widgetSetting),
    topicInfos,
    drillDownTypes: [''],
    drillDownFilter: {} as AnalysisFilter,
    topicId,
    rowComparisonMode,
    colComparisonMode,
    pivotThemeInfos,
    pivotRowThemeInfos,
    tagNames,
    rowTagNames,
    docNames,
    rowDocNames,
    selectedPivotThemeInfo,
    selectedPivotRowThemeInfo,
    selectedTagName,
    selectedRowTagName,
    selectedDocName,
    selectedRowDocName
  } as unknown) as InsightContentSettingType
  if (widgetSetting.precision) {
    insightContentSetting.precision = widgetSetting.precision
  }

  if (!selection) {
    return insightContentSetting
  }

  insightContentSetting.selectionFilter = composeDecoratedDetailSearchFilter(
    strategy,
    widgetSetting,
    [insight],
    pivot ? [pivot] : []
  )

  return insightContentSetting
}

export const addSelectionFilterToWidgetSetting = (
  widgetSetting: CrosstabWidgetsType,
  strategy: DecoratedWidgetSettingComposingStrategy,
  selection?: InsightObjective
) => {
  if (!widgetSetting || typeof widgetSetting !== 'object') {
    return {}
  }

  if (!selection) {
    return {}
  }

  const { topicInfos, selectedTopic } = widgetSetting
  const { insight, pivot, topicId } = selection!

  const drillDownWidgetSetting = composeDecoratedDrillDownWidgetSetting(
    strategy,
    widgetSetting,
    [insight],
    pivot ? [pivot] : []
  )

  drillDownWidgetSetting.selectedTopic =
    topicInfos?.find((topicInfo) => topicInfo.topicId === topicId) || selectedTopic
  return drillDownWidgetSetting
}
